export const POPUP_NOTIFICATION_ADD = "POPUP_NOTIFICATION_ADD";
export const POPUP_NOTIFICATION_REMOVE = "POPUP_NOTIFICATION_REMOVE";
